<template>
  <div class="d-flex flex-column flex-md-row align-items-start gap-4">
    <!-- Descripción -->
    <div class="flex-grow-1">
      <h6 class="text-primary mb-2">
        <font-awesome-icon :icon="['far', 'comment']" class="me-2" />
        Descripción
      </h6>

      <div v-if="editable">
        <textarea 
          v-model="planLocal.descripcion"
          class="form-control"
          rows="3"
          placeholder="Describa brevemente el objetivo del plan..."
          @blur="guardarCambios"
          style="resize: vertical;"
        ></textarea>
        <div class="d-flex justify-content-end mt-2">
          <button class="btn btn-secondary me-2" @click="cancelarCambios">Cancelar</button>
          <button class="btn btn-primary" @click="guardarCambios">Guardar</button>
        </div>
      </div>
      <div v-else>
        <p class="bg-light border rounded p-2 text-muted" style="white-space: pre-line;">
          {{ planLocal.descripcion || 'Sin descripción disponible.' }}
        </p>
      </div>
    </div>

    <!-- Estado: Objetivo cumplido -->
    <div class="flex-shrink-0 mt-3 mt-md-0">
      <div v-if="editable" class="form-check mb-2">
        <input 
          class="form-check-input"
          type="checkbox"
          v-model="planLocal.objetivo_cumplido"
          id="check-objetivo"
          @change="guardarCambios"
        />
        <label class="form-check-label" for="check-objetivo">
          Objetivo cumplido
        </label>
      </div>

      <div v-else class="text-muted small">
        <strong>Objetivo cumplido:</strong> 
        <span :class="planLocal.objetivo_cumplido ? 'text-success' : 'text-danger'">
          {{ planLocal.objetivo_cumplido ? 'Sí' : 'No' }}
        </span>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    plan: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      planLocal: { ...this.plan }, // Copia local de la prop
    };
  },
  methods: {
    guardarCambios() {
      this.$emit('guardar', this.planLocal); // Emitir los cambios al padre
    },
    cancelarCambios() {
      this.planLocal = { ...this.plan }; // Restaurar la copia local al estado original
      this.$emit('cancelar'); // Emitir el evento de cancelación al padre
    },
  },
  watch: {
    plan: {
      immediate: true,
      deep: true,
      handler(newPlan) {
        this.planLocal = { ...newPlan }; // Actualizar la copia local cuando la prop cambia
      },
    },
  },
};
</script>
  